/**
 * Dynamically injects this module's CSS into the document head.
 *
 * Required when the module is loaded as a remote via Module Federation: the
 * build sets `cssCodeSplit: false` and emits a standalone `assets/style.css`,
 * which is only referenced by this module's own `index.html`. Nothing links it
 * when the shell imports `remoteEntry.js`, so the module must inject it itself
 * rather than depend on the host doing it.
 */
export function injectStylesheet(href: string): void {
  const id = "mapping-module-styles";
  if (document.getElementById(id)) return;

  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
}
